import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
    Optional
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { GettingStartedSectionComponent } from '../../sections/client-initiated-loan/getting-started/getting-started-section.component';
import { AboutYouSectionComponent } from '../../sections/client-initiated-loan/about-you/about-you-section.component';
import { PropertySectionComponent } from '../../sections/client-initiated-loan/property/property-section.component';
import { IncomeAndAssetsSectionComponent } from '../../sections/client-initiated-loan/income-and-assets/income-and-assets-section.component';
import { SubmitSectionComponent } from '../../sections/client-initiated-loan/submit/submit-section.component';
import { StepSection } from '../../../enums/step-section.enum';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef
} from '@angular/material/dialog';
import {
    StepperContextService,
    StepperMode
} from '../../../services/stepper-context.service';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { StepperAnswersService } from '../../../services/stepper-answers.service';
import { GettingStartedSteps } from '../../../enums/getting-started-steps.enum';
import { LoanPurposeOptions } from '../../sections/client-initiated-loan/getting-started/steps/loan-purpose/loan-purpose.component';

@Component({
    selector: 'lgv-client-initiated-loan-stepper',
    standalone: true,
    imports: [
        CommonModule,
        GettingStartedSectionComponent,
        AboutYouSectionComponent,
        PropertySectionComponent,
        IncomeAndAssetsSectionComponent,
        SubmitSectionComponent
    ],
    templateUrl: './client-initiated-loan-stepper.component.html',
    styleUrls: ['./client-initiated-loan-stepper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientInitiatedLoanStepperComponent {
    @Input() agentIdParam: string;
    @Input() queryParams;
    StepSection = StepSection;

    public currentSection: StepSection = StepSection.GettingStarted;
    public specificStep = '';

    constructor(
        public dialog: MatDialog,
        public contextService: StepperContextService,
        public answerService: StepperAnswersService,
        @Optional()
        public dialogRef: MatDialogRef<ClientInitiatedLoanStepperComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private route: ActivatedRoute
    ) {
        if (data) {
            this.contextService.isDialog = true;
            this.contextService.agentId = this.data.agentId;
            if (Object.keys(data.clientInfo).length > 0) {
                this.contextService.mode = StepperMode.ClientMode;
                this.answerService.loadClientInfo(
                    data.clientInfo,
                    data.clientAddress
                );
            }
            if (data.fromQuickPricer) {
                this.answerService.loadDataFromQuickPricer(
                    data.fromQuickPricer
                );
            }
        }
    }
    ngOnInit() {
        if (!this.contextService.isDialog) {
            this.contextService.agentId =
                this.contextService.agentId === '' ? this.agentIdParam : '';
        }
        this.route.queryParams.pipe(first()).subscribe(queryParams => {
            const params = { ...queryParams };
            this.queryParams = params as Record<string, string>;
            if ('clientExternalId' in this.queryParams) {
                this.contextService.clientExternalId = this.queryParams.clientExternalId;
                delete this.queryParams.clientExternalId;
            }
            if ('isBeta' in this.queryParams) {
                this.contextService.isBeta = this.queryParams.isBeta === 'true';
                delete this.queryParams.isBeta;
            }
            this.answerService.prepopulateQueryParams(this.queryParams);
        });
    }

    onClose(): void {
        this.dialogRef?.close();
    }

    goToSection(event) {
        this.specificStep = event[1];
        this.currentSection = event[0];
    }
}
